export class ArrayOfType {
    type;

    name;

    constructor(type) {
        if (type == null) {
            throw new TypeError(`"type" argument invalid value: "${type}"`);
        }
        this.type = type;
        this.name = `${this.type.name}[]`.toLowerCase();
    }
}

export function ArrayOf(type) {
    return new ArrayOfType(type);
}